module.exports = __webpack_public_path__ + "static/media/fremantle-logo.797b4017.svg";